import axios from "axios";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { toast } from "react-toastify";
import ThanksImage from "../../../../components/Images/thankyou.svg";
import { useLocation } from "react-router-dom";
import NewSurveySubmitted from "../SubmittedSurvey/NewSurveySubmitted";
import BThankYou from "../ThankYou/BThankYou";

const NewBKnownUserResponsePage = (props) => {
  const { surveyCode, userUniqueId, cmp_fk_id, smId, geoData } = props;
  const [loading, setLoading] = useState(true);
  const [gridData, setGridData] = useState({});
  const [message, setMessage] = useState("");
  const [isSubmitted, setisSubmitted] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (
      gridData &&
      gridData.sections &&
      gridData.sections.length > 0 &&
      !isSubmitted
    ) {
      // Parse query params
      const params = new URLSearchParams(location.search);
      const sm_unique_code = params.get("survey_code");
      const cmp_fk_id_param = params.get("dcfh");
      const usr_unique_id = params.get("usrId");
      const npsqtype = params.get("npsqtype");
      const npsq = params.get("npsq");
      const npsa = params.get("npsa"); //nps options
      const npssec = params.get("npssec");

      // Check if all required params are present
      if (
        sm_unique_code &&
        cmp_fk_id_param &&
        usr_unique_id &&
        npsqtype &&
        npsq &&
        npsa &&
        npssec
      ) {
        const optiondata = [
          {
            que_fk_id: npsq,
            qtype_fk_id: npsqtype,
            que_is_mandatory: false,
            sec_fk_id: npssec,
            text_response: String(npsa),
            options: [String(npsa)],
          },
        ];

        // If all mandatory questions are filled, proceed to submit the form
        const data = {
          usr_unique_id: userUniqueId,
          sm_fk_id: smId,
          cmp_fk_id: cmp_fk_id,
          is_submit: true,
          responses: optiondata,
        };

        axios
          .post(
            process.env.REACT_APP_BASE_URL + "v1/survey/user/response/",
            data
          )
          .then((response) => {
            if (response.data.success === true) {
              setisSubmitted(true);
            } else {
              setisSubmitted(false);
              toast.error(
                "There was an error submitting the survey. Please try again."
              );
            }
          })
          .catch((error) => {
            // Handle any errors here
            console.error("API Error:", error);
            setisSubmitted(false);
          });
      } else {
        setisSubmitted(false);
      }
    }
  }, [location.search, gridData, isSubmitted]);

  useEffect(() => {
    if (smId && geoData.ip) {
      const getSurveyApiData = async () => {
        const data = {
          state: geoData.region || "",
          city: geoData.city || "",
          country: geoData.country || "",
          lat: geoData.lat ? geoData.lat : "",
          lon: geoData.lon ? geoData.lon : "",
          ipaddress: geoData.ip || "",
          name: "",
          email: "",
          mobile: "",
        };

        let urls;
        if (userUniqueId && cmp_fk_id) {
          urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SURVEY_USER_CAPTURE}/?sm_unique_code=${surveyCode}&cmp_fk_id=${cmp_fk_id}&usr_unique_id=${userUniqueId}`;
        } else if (userUniqueId) {
          urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SURVEY_USER_CAPTURE}/?usr_unique_id=${userUniqueId}&sm_unique_code=${surveyCode}`;
        }

        try {
          const res = await axios.post(urls, data);
          if (res.data) {
            // console.log("resdddd>>>", res.data);
            setGridData(res.data.data);
            setMessage(res.data.message);
          } else {
            setGridData([]);
          }
        } catch (err) {
          console.error("Error fetching survey data:", err);
        } finally {
          setLoading(false); // Hide loading after data is fetched
        }
      };

      getSurveyApiData();
    }
  }, [geoData, userUniqueId, surveyCode, smId, cmp_fk_id]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "94vh",
        }}
      >
        <CircularProgress size={72} thickness={3} />
      </Box>
    );
  }

  if (gridData.length === 0) {
    return <NewSurveySubmitted message={message} gridData={gridData} />;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {isSubmitted ? (
            <BThankYou ThanksImage={ThanksImage} gridData={gridData} />
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};
export default NewBKnownUserResponsePage;
